/*
  Miles buy box — gallery.

  Thumbnails swap the main image. Deliberately not Dawn's media-gallery.js:
  that expects <media-gallery>, <slider-component>, deferred-media and a set of
  generated ids, and brings its own layout with it. This gallery is one image
  and a row of buttons, and the whole behaviour is below.

  Progressive: the main image is rendered server-side and is correct with no
  JavaScript at all. This only adds the swapping.
*/
(function () {
  function init(gallery) {
    /* By class, not a data-* hook: the main image is built by the `image_tag`
       filter, which emits only the parameters it recognises and silently drops
       the rest — a data attribute passed to it never appears in the markup. */
    /* The theme editor's section:load fires for sections that initAll has
       already bound; a second pass would stack listeners. */
    if (gallery.dataset.buyboxInit) return;
    gallery.dataset.buyboxInit = '1';
    var main = gallery.querySelector('.miles-buybox__main-img');
    var thumbs = gallery.querySelectorAll('[data-buybox-thumb]');
    if (!main || thumbs.length < 2) return;

    function show(thumb) {
      /* srcset before src: the browser picks from srcset when both are
         present, so setting src first can paint the old candidate once. */
      main.srcset = thumb.dataset.srcset || '';
      main.src = thumb.dataset.full;
      main.alt = thumb.dataset.alt || '';
      Array.prototype.forEach.call(thumbs, function (t) {
        t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
      });
    }

    Array.prototype.forEach.call(thumbs, function (thumb, i) {
      thumb.addEventListener('click', function () {
        show(thumb);
      });

      /* Left/right walk the row and move focus with the selection, which is
         what a group of related controls is expected to do. */
      thumb.addEventListener('keydown', function (event) {
        var step = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
        if (!step) return;
        event.preventDefault();
        var next = thumbs[(i + step + thumbs.length) % thumbs.length];
        next.focus();
        show(next);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-buybox-gallery]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* The theme editor rebuilds a section's markup in place, which drops the
     listeners attached above. */
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-buybox-gallery]').forEach(init);
  });
})();
